import { render, staticRenderFns } from "./NFSEntrada.vue?vue&type=template&id=38e97246"
import script from "./NFSEntrada.vue?vue&type=script&lang=js"
export * from "./NFSEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports